exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dash-logout-btn {\n    padding: 1rem;\n    background-color: #119DFF;\n    border: 1px solid #119DFF;\n    color: #ffffff;\n    outline: none;\n    cursor: pointer;\n    text-align: center;\n}\n\n.dash-logout-btn:hover, .dash-logout-btn:focus {\n    background-color: #0d76bf;\n    border: 1px solid #0d76bf;\n}\n\n.dash-logout-frame {\n    display: block;\n    padding: 0;\n    margin: 0;\n}\n", ""]);

// exports
